import moment from 'moment'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    index: {
      parkCode: null,
      purpose: null,
      reservee: null,
      type: null,
      lights: null,
      status: null,
      turfType: null,
      startDate: moment().startOf('month').format('YYYY-MM-DD'),
      endDate: null,
      timeRange: ['0:00', '23:59']
    },
    details: {
      view: 'park',
      parkCode: null,
      fieldCode: null,
      purpose: null,
      reservee: null,
      timeRange: ['0:00', '23:59'],
      month: moment().format('M'),
      year: moment().format('YYYY')
    },
    config: {
      minDate: moment().subtract(1, 'year').startOf('year').format('YYYY-MM-DD'),
      maxDate: moment().add(3, 'months').endOf('month').format('YYYY-MM-DD')
    },
    s3Timestamp: {
      status: 'uninitialized', // uninitialized || loading || success || error
      value: null,
      pullTime: null
    }
  },
  mutations: {
    // Else-ifs are a bit messy, but just for date validation. Could be cleaned up.
    setIndex (state, {filter, value}) {
      if(filter == 'startDate' && moment(value).isBefore(state.config.minDate))
        state.index.startDate = state.config.minDate
      else if(filter == 'startDate' && moment(value).isAfter(state.config.maxDate))
        state.index.startDate = state.config.maxDate
      else if(filter == 'endDate' && value !== null && !moment(value).isBetween(state.config.minDate, state.config.maxDate))
        state.index.endDate = null
      else
        state.index[filter] = value
    },
    clearIndex (state) {
      state.index = {
        parkCode: null,
        purpose: null,
        reservee: null,
        type: null,
        lights: null,
        status: null,
        turfType: null,
        startDate: moment().startOf('month').format('YYYY-MM-DD'),
        endDate: null,
        timeRange: ['0:00', '23:59']
      }
    },
    // Else-ifs are a bit messy, but just for date validation. Could be cleaned up.
    setDetails (state, {filter, value}) {
      if(filter == 'month' && moment().month(value-1).year(state.details.year).isBefore(state.config.minDate)
          || filter == 'year' && moment().month(state.details.month-1).year(value).isBefore(state.config.minDate))
        [state.details.month, state.details.year] = moment(state.config.minDate).format('M-YYYY').split('-')
      else if(filter == 'month' && moment().month(value-1).year(state.details.year).isAfter(state.config.maxDate)
          || filter == 'year' && moment().month(state.details.month-1).year(value).isAfter(state.config.maxDate))
        [state.details.month, state.details.year] = moment(state.config.maxDate).format('M-YYYY').split('-')
      else
        state.details[filter] = value
    },
    clearDetails (state) {
      state.details = {
        view: 'park',
        parkCode: null,
        fieldCode: null,
        purpose: null,
        reservee: null,
        timeRange: ['0:00', '23:59'],
        month: moment().format('M'),
        year: moment().format('YYYY')
      }
    },
    setS3Timestamp (state, {status, value}) {
      state.s3Timestamp = {
        status,
        value,
        pullTime: moment()
      }
    }
  }
})